import request from '@/utils/request'


export function statistics(data) {
  return request({
    url: '/admin/statistics',
    method: 'post',
    data
  })
}

export function userList(data) {
  return request({
    url: '/admin/userList',
    method: 'post',
    data
  })
}

export function userInfo(data) {
  return request({
    url: '/admin/userInfo',
    method: 'post',
    data
  })
}

export function detailList(data) {
  return request({
    url: '/admin/account/detail/list',
    method: 'post',
    data
  })
}

export function addUser(data) {
  return request({
    url: '/admin/addUser',
    method: 'post',
    data
  })
}

export function updateUser(data) {
  return request({
    url: '/admin/updateUser',
    method: 'post',
    data
  })
}

export function userDisable(data) {
  return request({
    url: '/admin/disableUser',
    method: 'post',
    data
  })
}

export function userTop(data) {
  return request({
    url: '/admin/top',
    method: 'post',
    data
  })
}

export function userDisableTx(data) {
  return request({
    url: '/admin/disableTx',
    method: 'post',
    data
  })
}

export function userDelete(data) {
  return request({
    url: '/admin/delUser',
    method: 'post',
    data
  })
}

// 订单
export function orderList(data) {
  return request({
    url: '/admin/orderList',
    method: 'post',
    data
  })
}


export function check(data) {
  return request({
    url: '/admin/check',
    method: 'post',
    data
  })
}
// 查看全局配置
export function configure(data) {
  return request({
    url: '/admin/configure',
    method: 'post',
    data
  })
}

export function upConfigure(data) {
  return request({
    url: '/admin/updConfigure',
    method: 'post',
    data
  })
}

export function setPassword(data) {
  return request({
    url: '/admin/setPassword',
    method: 'post',
    data
  })
}

export function userWithdrawList(data) {
  return request({
    url: '/admin/extract/cash/list',
    method: 'post',
    data
  })
}

export function userDetailList(data) {
  return request({
    url: '/admin/account/detail/list',
    method: 'post',
    data
  })
}

export function goodsList(data) {
  return request({
    url: '/admin/goodsList',
    method: 'post',
    data
  })
}

export function delAll(data) {
  return request({
    url: '/admin/delAll',
    method: 'post',
    data
  })
}

export function clearTaskNum(data) {
  return request({
    url: '/admin/clearTaskNum',
    method: 'post',
    data
  })
} 

export function accountInfo() {
  return request({
    url: 'admin/user/accountInfo',
    method: 'post'
  })
}

export function extract(data) {
  return request({
    url: 'admin/agent/extract',
    method: 'post',
    data
  })
}

export function sendTask(data) {
  return request({
    url: '/admin/sendTask',
    method: 'post',
    data
  })
}

export function reminder(params) {
  return request({
    url: '/admin/reminder',
    method: 'post',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/common.js